import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import {
  AgencyData,
  OwnerDetailsPayload,
} from 'redux/types/agency-onboarding/Agency.types';

export interface BasicDetails {
  loading: boolean;
  error: string | null;
  data: AgencyData;
  success: boolean | null;
}

export interface BasicDetailsData {
  companyType?: string | null;
  collectionChannels?: string[];
  allocators?: {
    allocatorId: string;
    status: string;
    totalAgents: number;
    allocatorType: string;
  }[];
  totalTeleCallingAgents?: string | null;
  totalFosAgents?: number | null;
  totalNumberOfAgents?: number | null;
  languagesCateredOnCalling?: string[];
  yearsInBusiness?: string | null;
  cityCovered?: string[];
  agencyId: string;
}

export interface ProductBucketItem {
  productId: string;
  bucketIds: string[];
  allocatorIds: string[];
  is_expert: boolean;
}

export interface ProductBucketPayload {
  agencyId: string;
  productBucketList: ProductBucketItem[];
}

export const basicDetailsState: BasicDetails = {
  data: {
    companyType: '',
    agencyChannelsList: [],
    agencyAllocatorsList: [],
    totalTeleAgents: 0,
    totalFosAgents: 0,
    yearOfBusiness: '',
    agencyCityCoveredList: [],
  },
  loading: false,
  error: null,
  success: null,
};

const BasicDetailsSlice = createSlice({
  name: 'form',
  initialState: basicDetailsState,
  reducers: {
    setField: (state, action: PayloadAction<AgencyData>) => {
      state.data = action.payload as AgencyData;
      state.success = true;
    },
    submitData: (state, action: PayloadAction<BasicDetailsData>) => {
      state.loading = true;
      state.success = null;
    },
    submitProductBucket: (
      state,
      action: PayloadAction<ProductBucketPayload>
    ) => {
      state.loading = true;
      state.success = null;
    },
    submitOwnerDetails: (state, action: PayloadAction<OwnerDetailsPayload>) => {
      state.loading = true;
      state.success = null;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setSuccess: (state, action: PayloadAction<any | null>) => {
      state.success = action.payload;
    },
  },
});

export const {
  setField,
  setLoading,
  setError,
  submitData,
  submitProductBucket,
  submitOwnerDetails,
  setSuccess,
} = BasicDetailsSlice.actions;

export default BasicDetailsSlice.reducer;
